<template>
    <div>
        <x-panel margin class=" mb-5" v-if="marketingPartner && _.has(referral_data, 'goals')">
            <div slot="title">
                <h3>Lead Management</h3>
            </div>
            <div slot="extra" :class="`d-flex justify-content-end`">

            </div>
            <el-row :gutter="12" class="lead-stats">
                <el-col class="col-12 col-sm-6 col-xl-3 mb-2 mb-xl-0 box-card ml-0 mr-0">
                    <el-card shadow="never">
                        <div slot="header" class="clearfix">
                            <span>Requested / Delivered</span>
                            <el-tag size="mini" type="success" style="float: right;"
                                    @click="selectedChart = lineChartData.month">
                                This Month
                            </el-tag>
                        </div>
                        <div class="split-content">
                            <div class="left">
                                <h2>{{ referral_data.goals.monthly.requested }}</h2>
                            </div>
                            <div class="right">
                                <h2>{{ referral_data.goals.monthly.delivered }}</h2>
                            </div>
                        </div>
                    </el-card>
                </el-col>
                <el-col class="col-12 col-sm-6 col-xl-3 mb-2 mb-xl-0 box-card ml-0 mr-0">
                    <el-card shadow="never">
                        <div slot="header" class="clearfix">
                            <span>Requested / Delivered</span>
                            <el-tag size="mini" type="warning" style="float: right;"
                                    @click="selectedChart = lineChartData.today">Today
                            </el-tag>
                        </div>
                        <div class="split-content">
                            <div class="left">
                                <h2 v-if="!referral_data.goals.daily.requested">{{ daily_target }}</h2>
                                <h2 v-else>{{ referral_data.goals.daily.requested }}</h2>
                            </div>
                            <div class="right">
                                <h2>{{ referral_data.goals.daily.delivered }}</h2>
                            </div>
                        </div>
                    </el-card>
                </el-col>
                <el-col class="col-12 col-sm-6 col-xl-3 mb-2 mb-xl-0 box-card ml-0 mr-0">
                    <el-card shadow="never">
                        <div slot="header" class="clearfix">
                            <span>Avg. NAF</span>
                            <el-tag size="mini" type="info" style="float: right;">This Month</el-tag>
                        </div>
                        <h2>
                            <sup>$</sup>
                            {{ averageNaf }}
                        </h2>
                    </el-card>
                </el-col>
                <el-col class="col-12 col-sm-6 col-xl-3 mb-2 mb-xl-0 box-card ml-0 mr-0">
                    <el-card shadow="never">
                        <div slot="header" class="clearfix">
                            <span>Daily leads to hit monthly target</span>
                        </div>
                        <h2>{{ daily_target }}</h2>
                    </el-card>
                </el-col>
            </el-row>
        </x-panel>
        <el-row v-if="showStatChart" style="background:#fff;padding:16px 16px 0;margin-bottom:32px;">
            <mix-chart :key="selectedChart" :chart-data="selectedChart ? selectedChart : lineChartData.month"/>
        </el-row>
        <x-panel>
            <div slot="title">
                <h4>Lead Order</h4>
            </div>
            <div slot="extra" :class="`d-flex justify-content-end`">
                <el-button size="mini" :disabled="loading" @click="save" type="success">Set Tomorrows Leads</el-button>
                <el-button size="mini" :disabled="loading" @click="saveMonthly" type="success">Set {{nextMonth}} Leads</el-button>
            </div>
            <el-form ref="managementConfig" :model="leadManagement" label-position="top">

                <div class="settings-section">

                    <el-row :gutter="10">
                        <el-col :sm="12" :md="12" :lg="6">
                            <el-form-item label="Default Daily">
                                <el-input-number :disabled="true" class="w-100" controls-position="right"
                                                 v-model="leadManagement.default_daily" :min="0"></el-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col :sm="12" :md="12" :lg="6">
                            <el-form-item :label="`${nextBusinessDay} (Next Business Day)`">
                                <el-input-number class="w-100" controls-position="right"
                                                 v-model="leadManagement.tomorrow_leads" :min="0"></el-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col :sm="12" :md="12" :lg="6">
                            <el-form-item label="Default Monthly">
                                <el-input-number :disabled="true" class="w-100" controls-position="right"
                                                 v-model="leadManagement.default_monthly" :min="0"></el-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col :sm="12" :md="12" :lg="6">
                            <el-form-item :label="`${nextMonth} (Next Month)`">
                                <el-input-number class="w-100" controls-position="right"
                                                 v-model="leadManagement.next_months_leads" :min="0"></el-input-number>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </el-form>
        </x-panel>
    </div>
</template>

<script>
import {Message} from "element-ui"
import LineChart from "./LineChart"
import MixChart from "./MixChart"
import moment from "moment"

export default {
    name: "LeadManagementSettings",
    props: {
        tenant: Number,
    },
    components: {
        LineChart,
        MixChart,
    },
    data() {
        return {
            leadManagement: {
                default_daily: 0,
                tomorrow_leads: 0,
                default_monthly: 0,
                next_months_leads: 0,
            },
            showStatChart: false,
            referral_data: {},
            selectedChart: false,
            loading: true,
            lineChartData: {
                month: {
                    title: "Monthly Statisics",
                    requestedData: [8, 5, 10, 10, 10, 5, 0, 8, 5, 10, 10, 10, 5, 0, 8, 5, 10, 10, 10, 5, 0, 8, 5, 10, 10, 10, 5, 0],
                    receivedData: [8, 8, 10, 10, 10, 8, 5, 8, 5, 10, 10, 10, 5, 0, 10, 5, 10, 10, 10, 10, 0, 8, 5, 10, 10, 10, 5, 5],
                    dataType: "month",
                    data: "2021-02"
                },
                today: {
                    title: "Todays Statisics",
                    requestedData: [100, 120, 161, 134, 105, 160, 165],
                    receivedData: [120, 82, 91, 154, 162, 140, 145],
                    dataType: "day"
                }
            },
            marketingPartner: false,
            collection: {},
            limit: 10
        }
    },
    computed: {
        averageNaf() {
            if (this.referral_data.goals.monthly.delivered > 0) {
                let averageNaf = this.referral_data.goals.monthly.leads_amount / this.referral_data.goals.monthly.delivered
                return Number(averageNaf).toLocaleString("en-AU", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
            }
            return Number(0).toLocaleString("en-AU", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })
        },
        remaining_leads() {
            let remaining = Number(this.referral_data.goals.monthly.requested) - this.referral_data.goals.monthly.delivered
            return remaining > 0 ? remaining : 0;
        },
        target_low() {
            return ((Number(this.referral_data.goals.monthly.requested) - this.referral_data.goals.monthly.delivered) /
                Number(this.referral_data.goals.monthly.requested)) *
            100 <=
            10
                ? true
                : false
        },
        daily_target() {
            let target = Number(
                (Number(this.referral_data.goals.monthly.requested) - this.referral_data.goals.monthly.delivered) /
                this.referral_data.workingDaysLeft
            ).toFixed(0);


            return target > 0 ? target : 0;
        },
        nextMonth() {
            return moment().add(1, 'months').format('MMMM');
        },
        nextBusinessDay() {
            let dayIncrement = 1;
            if (moment().day() === 5) {
                // set to monday
                dayIncrement = 3;
            } else if (moment().day() === 6) {
                // set to monday
                dayIncrement = 2;
            }
            return moment().add(dayIncrement, 'days').format('dddd 	Do MMMM');
        }
    },
    created() {
        // this.getStats = _.debounce(this.getStats, 5000)
        this.marketingPartner = _.get(this.Ambition, "Globals.tenant.enable_marketing_partner", false)
        this.getStats()
    },
    mounted() {
        this.$bus.$on("lead::statistics::reload", data => {
            this.getStats()
        })

        const onListen = _.debounce(async (e) => {
            this.getStats()

        }, 5000)

        // build echo endpoint to auto load leads in tenant
        Echo.private("lead_management_tab." + this.tenant)
            .listen(".update", onListen)
    },
    watch: {
        tenantId(newVal, oldVal) {
            this.tenantId = newVal
            this.$store.commit("leadTable/SET_CUSTOM_FILTER", {filter: "tenantId", value: newVal})
        }
    },
    beforeCreate() {
    },
    beforeDestroy() {
        this.$bus.$off("lead::statistics::reload")
    },
    methods: {
        getStats() {
            this.$tenant
                .post(
                    `/api/lead-management/stats`, {
                        team_id: _.get(window.TenantGlobals, 'currentTeamId', null)
                    }
                )
                .then(res => {
                    this.$set(this.$data, "referral_data", res.data.referral_data)

                    this.leadManagement = {
                        default_daily: _.get(res.data.referral_data, 'goals.daily.default', 0) || Math.round(_.get(res.data.referral_data, 'goals.monthly.requested', 0) / _.get(res.data.referral_data, 'workingDaysInMonth', 0)),
                        tomorrow_leads: _.get(res.data.referral_data, 'tomorrow') !== false ? _.get(res.data.referral_data, 'tomorrow') : this.daily_target,
                        default_monthly: _.get(res.data.referral_data, 'goals.monthly.default', 0) || _.get(res.data.referral_data, 'goals.monthly.requested', 0),
                        next_months_leads: _.get(res.data.referral_data, 'nextMonth', 0)
                    }
                    this.loading = false
                })
        },

        save() {
            this.$tenant
                .post(
                    `/api/lead-management/request/set-leads`,
                    {
                        ...this.leadManagement,
                        team_id: _.get(window.TenantGlobals, 'currentTeamId', null)
                    })
                .then(response => {
                    Message({
                        message: "Lead targets updated",
                        type: "success"
                    })
                })
                .catch(error => {
                    Message({
                        message: error.message,
                        type: "error"
                    })
                })
        },

        saveMonthly() {
            this.$tenant
                .post(
                    `/api/lead-management/request/set-monthly-leads`,
                    {
                        ...this.leadManagement,
                        team_id: _.get(window.TenantGlobals, 'currentTeamId', null)
                    })
                .then(response => {
                    Message({
                        message: `${this.nextMonth} Lead target updated`,
                        type: "success"
                    })
                })
                .catch(error => {
                    Message({
                        message: error.message,
                        type: "error"
                    })
                })
        },
    }
}
</script>
<style lang="scss">
.table-scrollbar {
    position: relative;
    height: auto;
    max-height: 230px;
    overflow-y: auto;
}

.table-wrapper-scroll-y {
    display: block;
}

.tableFixHead {
    thead th {
        position: sticky;
        top: 0;
        z-index: 1;
    }
}

.el-date-editor .el-range-separator {
    padding: 0 5px;
    line-height: 32px;
    width: 10%;
    color: #303133;
}

.lead-stats {
    .box-card {
        .el-card__header {
            font-weight: 600;
            color: #7d7d7d;

            .el-tag {
                font-weight: 400;
            }
        }

        .el-card__body {
            padding: 0px !important;

            h2 {
                padding: 20px;
                color: #797979 !important;
                text-align: center;
            }

            .split-content {
                display: flex;
                width: 100%;
                justify-content: space-around;
                align-items: center;

                .left {
                    flex-grow: 1;
                    align-items: center;
                    justify-content: center;
                    display: flex;
                    padding: 20px;

                    h2 {
                        padding: 0px;
                        color: #797979 !important;
                    }
                }

                .right {
                    flex-grow: 1;
                    align-items: center;
                    justify-content: center;
                    display: flex;
                    padding: 20px;
                    clip-path: polygon(17% 0%, 100% 0%, 100% 100%, 0% 100%);
                    background: #68c23a;

                    h2 {
                        padding: 0px;
                        color: #fff !important;
                    }
                }
            }
        }
    }
}

.admin-additional-data {
    background: #f1f1f1 !important;
    min-width: 12.5rem;
}

.table td {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
}

.table th.no-padding {
    padding-left: 0rem !important;
    padding-right: 0rem !important;
}

.lead-manager {
    &.el-table {
        th,
        td {
            font-size: smaller !important;

            p {
                font-size: smaller !important;
            }
        }

        td {
            .el-badge {
                margin: 0.5rem !important;
            }
        }
    }

    .warning-row {
        background-color: #ffeaea;
    }
}

.filters-dropdown {
    background: #e7e7e7;
    border: 0px;
    border-radius: 0px;
    margin-bottom: 15px;
}

.filters-dropdown .panel {
    background: transparent !important;
    border: none !important;
}
</style>
